import Plyr from 'plyr';
import { gsap } from 'gsap';
import { eventBus, withPlugins, device } from '@spon/plugins';

function VideoSingleImageHeroPlayer({ node, plugins: { device } }) {
	let landscape = window.innerWidth > window.innerHeight;

	const nodeId = node.id; // video Id
	const config = JSON.parse(node.dataset.config) ?? {};

	const plyrOpts = {
		settings: [],
		volume: config.volume ?? 1,
		muted: config.muted === 1 ? true : false,
		keyboard: { focused: false },
		tooltips: { seek: false },
		loop: config.loop ? { active: true } : { active: false },
		storage: { enabled: false },

		controls:
			config.controls == 1
				? [
						'play-large',
						'play',
						'progress',
						'current-time',
						'mute',
						'volume',
						'fullscreen',
				  ]
				: [],
		hideControls: true,
		speed: { selected: 1, options: [] },
		fullscreen: {
			enabled: true,
			fallback: true,
			iosNative: true,
			container: 'c-video-container',
		},
		autopause: config.autopause ?? 0,
		autoplay: config.autoplay === 1 ? true : false,
	};

	let player;

	const init = () => {
		player = new Plyr(node, plyrOpts);

		player.once('ready', () => {
			gsap.to(node, {
				opacity: 1,
				duration: 0.6,
				ease: 'linear',
			});

			if (plyrOpts.autoplay) {
				player.muted = true;
				player.play();
			}
		});

		eventBus.on(`stopVideo-${nodeId}`, () => {
			log(`stopVideo-${nodeId} truggered`);
			player.pause();
			player.currentTime = 0;
		});

		eventBus.on(`muteVideo-${nodeId}`, () => {
			// log(`stopVideo-${nodeId} truggered`);
			player.muted = true;
			player.volume = 0;
		});

		eventBus.on(`unmuteVideo-${nodeId}`, () => {
			// log(`stopVideo-${nodeId} truggered`);
			player.muted = false;
			player.volume = 0.7;
		});
	};

	if (landscape) {
		init();
	}

	device.resize(() => {
		// update the landscape vairable - bool
		landscape = window.innerWidth > window.innerHeight;

		// if the screen is shrunk pause the vid
		if (!landscape && player) {
			if (player.playing) {
				log('pause');
				player.pause();
			}
		}

		// if the screen us expanded play the vid
		if (landscape && player) {
			if (!player.playing) player.play();
		}

		// if the screen was opened in portrait and then expanded to landscape, init the player
		if (landscape && !player) {
			init();
		}
	});

	return () => {
		if (player) player.destroy();
	};
}

export default withPlugins(device)(VideoSingleImageHeroPlayer);
